const SCOPE = "[Notifications]";

export class LoadInbox {
  static readonly type = `${SCOPE} Load Inbox`;
  constructor(
    public tenant: string,
    public pageIndex = 0
  ) {}
}
export class MarkAsRead {
  static readonly type = `${SCOPE} Mark As Read`;
  constructor(
    public tenant: string,
    public deliveryId: number
  ) {}
}
export class MarkAllAsRead {
  static readonly type = `${SCOPE} Mark All As Read`;
  constructor(public tenant: string) {}
}
export class AddIncomingPush {
  static readonly type = `${SCOPE} Add Incoming Push`;
  constructor(public tenant: string) {}
}
export class ClearNotifications {
  static readonly type = `${SCOPE} Clear`;
}
